// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"3e4f492f","453":"f7c47fab","905":"a98bddc3"}[chunkId] + ".chunk.js";
};